import React from 'react'
import { Link } from 'react-router-dom';

const Menu = ({isActive,rule,index}) => {
    const attributes = rule?.ContentRuleZone?.[0]?.attributes;
    const subMenus = rule?.ContentRuleZone?.[0]?.subMenus;
    const topCategories =rule?.ContentRuleZone?.[0]?.topCategories;
    const mostPopular =rule?.ContentRuleZone?.[0]?.mostPopular;
    const ruleData = rule?.ContentRuleZone?.[0]
    const getTopCategoriesOrMostPopularName = (rule) => {
        if (rule?.topCategories?.length > 0) {
            return "Top Categories";
        } else if (rule?.mostPopular?.length > 0) {
            return "Most Popular";
        }
        return "";
    }

    const renderTopCategoriesOrMostPopularList = (topCategoriesOrMostPopularlist) => {
        if (topCategoriesOrMostPopularlist) {
            return topCategoriesOrMostPopularlist.map((menuItem, index) => {
                return (
                    <li className='top-category-list'>
                        <Link className='text-decoration-none d-flex top-category-link' to={menuItem.link ?? ""}>
                            <div className='top-category-img'>
                                <img fetchpriority="high" className='img-fluid' src={menuItem.imageUrl ?? ""} />
                            </div>
                            <div className='top-category-details'>
                                <h4 className='top-category-title'>{menuItem.displayName ?? ""}</h4>
                                <p className='top-category-content' dangerouslySetInnerHTML={{ __html: menuItem.description ?? "" }}></p>
                            </div>
                        </Link>
                    </li>
                )
            })
        } else {
            return <></>
        }
    }
    return (
        <li className={`c-nav-menu-l1 d-flex ${index === 0 && isActive ? 'active' : ''}`} key={index}>
            {attributes.link && attributes.link.includes("https") ?
                <a className="dropdown-item item-hover-related w-25" href={attributes.link ?? ""}>{attributes.displayName ?? ""}</a> :
                <Link className="dropdown-item item-hover-related w-25" to={attributes.link ?? ""}>{attributes.displayName ?? ""}</Link>}

            <div className={`w-75 tab-hover-catagory c-nav-menu-l2  ${index === 0 && isActive ? 'd-block' : ''}`} >
                <div className='row mx-0 tab-item-list'>
                    <div className='col-12 col-lg-7'>
                    <h3 className='item-display-name' dangerouslySetInnerHTML={{ __html: attributes.displayName ?? "" }}></h3>
                    <p className='item-display-content' dangerouslySetInnerHTML={{ __html: attributes.description ?? "" }}></p>
                        <ul className='row list-unstyled d-flex'>
                            {subMenus && subMenus.map((submenuItem, index) => {
                                return (
                                    <>
                                        <li className='col-6'>
                                            {submenuItem.link && submenuItem.link.includes("https") ?
                                                <a className='text-decoration-none subitem-display-name' href={submenuItem.link ?? ""}>{submenuItem.displayName ? submenuItem.displayName : ""}</a> :
                                                <Link className='text-decoration-none subitem-display-name' to={submenuItem.link ?? ""}>{submenuItem.displayName ? submenuItem.displayName : ""}</Link>}
                                        </li>
                                    </>
                                )
                            })}
                            <div className='row'>
                                <div className='col text-center'>
                                    {attributes.link && attributes.link.includes("https") ?
                                        <a className='btn btn-primary submit-display-btn' href={attributes.link ?? ""}>{`View all ${attributes.displayName ?? ""}`}</a> :
                                        <Link className='btn btn-primary submit-display-btn' to={attributes.link ?? ""}>{`View all ${attributes.displayName ?? ""}`}</Link>}
                                </div>
                            </div>
                        </ul>
                    </div>

                    <div className='col-12 col-lg-5 header-categories-features'>
                        {topCategories && topCategories.length > 0 || mostPopular && mostPopular.length > 0 ?
                            <>
                                <h3>{getTopCategoriesOrMostPopularName(ruleData)}</h3>
                                <ul className='row list-unstyled header-categories-subnav-popular'>
                                    {renderTopCategoriesOrMostPopularList(topCategories.length > 0 ? topCategories : mostPopular)}
                                </ul>
                            </> : <></>}
                    </div>

                </div>
            </div>

        </li>
    )
}

export default Menu